<template>
	<div class="multi-axis-motion-platform-list">
		<div class="multi-axis-motion-platform-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Multi-axis Motion Test Platform</span>
			</div>

			<div class="list">
				<img :src="solution_image_01"/>
				<ul>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">
							In order to study multi-axis motion control technology, we have built a high-precision 5-axis motion test platform, including: Beckhoff motion controller, Panasonic servo drive, Panasonic servo motor, IKO high-precision guide rail, IKO high-precision ball screw,  Harmonic Driver, Heidenhain grating feedback system, Omron optical fiber coaxial displacement sensor. The repeat positioning accuracy of the test platform reaches 0.005mm.
						</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">
							In order to study the mechanical error model of multi-axis motion control, we used Renishaw contact probes, Renishaw laser interferometers, and Renishaw rotary axis calibration components to measure various mechanical structural errors of the five-axis machine tool, and compensate the machinery Structural error through algorithms. The validity is finally verified on the test bench.
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_precision_05.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
		.dot {
			width: .625rem;
			border: none;
			text-align: left;
		}

		.ll {
			width: calc(100% - .625rem);
			border: none;
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.5rem;
			margin-bottom: 1.375rem;
		}

		.list > img {
			width: 100%;
			margin-bottom: 2rem;
		}

		.list > ul {
			width: 100%;
			height: 21rem;
		}

		.list {
			width: 54.5rem;
			margin-left: 7rem;
		}

		.multi-axis-motion-platform-con {
			width: 61.5rem;
			height: 70.125rem;
			margin-left: 0;
			border: none;
		}

		.multi-axis-motion-platform-list {
			width: 100%;
			border: none;
			height: 58.5625rem;
		}

		.x-tit-con {
			font-size: 1.5rem;
			color: #3B3A38;
			line-height: 3.25rem;
		}

		.title {
			width: calc(100% - 3.25rem);
			text-align: left;
			margin-left: 3.25rem;
			margin-top: 2.75rem;
			margin-bottom: 2.75rem;
		}

		.x-icon-keys {
			display: inline-block;
			content: url("../../../assets/resource/icons/ico_solutions.png");
			width: 2.75rem;
			height: 2.75rem;
			position: relative;
			top: .625rem;
			margin-right: 1rem;
		}

		/*.warnning {

			width: 100%;
			height: 100px;
			margin: 0 auto;
			text-align: center;
			font-style: oblique;
			font-size: 64px;
			font-family: "Open Sans";
			margin-top: 44px;
			margin-bottom: 44px;

		}*/
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-multi-axis-motion-platform.vue